import React from 'react';
import { DatePicker, Row, Col, Select, Checkbox } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={7} md={3} lg={3} xl={3} xxl={2} className="mt-5">
                        <label className="label">Periodo Inicio</label>
                    </Col>
                    <Col className="gutter-row" sm={7} md={4} lg={4} xl={3} xxl={2}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.anioInicio ?
                                    { key: this.props.filter.anioInicio } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por año inicio" />}
                            onChange={(option) => this.props.onChange("anioInicio", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.anios.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={10} md={5} lg={5} xl={3} xxl={2}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.mesInicio ?
                                    { key: this.props.filter.mesInicio } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por mes inicio" />}
                            onChange={(option) => this.props.onChange("mesInicio", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.meses.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={7} md={3} lg={3} xl={3} xxl={2} className="mt-5">
                        <label className="label">Periodo Fin</label>
                    </Col>
                    <Col className="gutter-row" sm={7} md={4} lg={4} xl={3} xxl={2}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.anioFin ?
                                    { key: this.props.filter.anioFin } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por año fin" />}
                            onChange={(option) => this.props.onChange("anioFin", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.anios.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={10} md={5} lg={5} xl={3} xxl={2}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.mesFin ?
                                    { key: this.props.filter.mesFin } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por mes fin" />}
                            onChange={(option) => this.props.onChange("mesFin", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.meses.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={24} lg={3}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'right' }} >
                            <Checkbox
                            checked={this.props.filter.flagNotaVenta}
                            onChange={(e) => this.props.onChange("flagNotaVenta", e.target.checked)}
                        >Incluir Nota de Venta</Checkbox>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;
